import { createIdempotencyKey, request } from "../api/client";

export interface FirstLoginManagerPinState {
  configured: boolean;
}

export function getFirstLoginManagerPinState(): Promise<FirstLoginManagerPinState> {
  return request<FirstLoginManagerPinState>("/api/v1/onboarding/first-login/manager-pin");
}

export function setFirstLoginManagerPin(
  pin: string,
  idempotencyKey = createIdempotencyKey()
): Promise<FirstLoginManagerPinState> {
  return request<FirstLoginManagerPinState>(
    "/api/v1/onboarding/first-login/manager-pin",
    {
      method: "PUT",
      headers: { "Idempotency-Key": idempotencyKey },
      body: JSON.stringify({ pin })
    }
  );
}
